import { add } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';

// import * as dateFnsTz from 'date-fns-tz';

import { DissertacooItemProps } from "@/@types/PosGraduacao/ListaDissertacoesTeses"
import { Card, CardContent } from '@/components/ui/card';


export default function DissertacaoItem({ dissertacao }: DissertacooItemProps) {
  // console.log(dateFnsTz);
  
  const formatDate = (dateString: string) => {
    const timeZone = 'America/Sao_Paulo';
    const options: Intl.DateTimeFormatOptions = { 
      timeZone, 
      year: 'numeric', 
      month:'2-digit', 
      day:'2-digit' 
    };

    const zoneDate = toZonedTime(new Date(dateString), timeZone)
    const adjustedDate = add(zoneDate, {hours:3})

    const formattedDate = new Intl.DateTimeFormat('pt-BR', options).format(adjustedDate)
    // return format(date, 'dd/MM/yyyy');
    return formattedDate;

  };

  return (

    <Card className='mt-[20px] lg:w-[45%] transition-all duration-100 hover:bg-gray-50'>
      <CardContent className='md:flex  p-[0.75rem] font-normal space-y-[15px]'>

        <div className='flex-1 space-y-[15px]'>
          <p className='text-colorSecondary font-semibold'>{dissertacao.etapas?.psecretcpgagenda ? 'Agenda' : 'Pré-Agenda'}</p>

          <p>
            <i className="fas fa-user mr-[5px] text-colorPrimary"></i>
            <strong className='text-colorPrimary font-semibold'>Aluno(a):</strong> {dissertacao.aluno.aluno}
          </p>

          <p>
            <i className='far fa-calendar-alt mr-[5px] text-colorPrimary'></i>  
            <strong className='text-colorPrimary font-semibold'>Data:</strong> {dissertacao.etapas?.psecretcpgagenda ? formatDate(dissertacao?.agenda?.dataagenda) : formatDate(dissertacao.examequalificacao) }
          </p>

          <p>
            <i className='far fa-clock mr-[5px] text-colorPrimary'></i>
            <strong className='text-colorPrimary font-semibold'>Horário:</strong> {dissertacao?.agenda?.iniHora}
          </p>

          <p>
            <i className='fas fa-chair mr-[5px] text-colorPrimary'></i>
            <strong className='text-colorPrimary font-semibold'>Sala:</strong> {dissertacao?.agenda?.local?.sigla} - {dissertacao?.agenda?.local?.descricaoLocal}
          </p>

        </div>

        <div className='flex-1 space-y-[15px]'>

          <p>
            <i className="fas fa-tag mr-[5px] text-colorPrimary"></i>
            <strong className='text-colorPrimary font-semibold'>Título:</strong> {dissertacao.titulo}
          </p>

          <p>
            <i className="fas fa-user-graduate mr-[5px] text-colorPrimary"></i>
            <strong className='text-colorPrimary font-semibold'>Orientador(a):</strong> {dissertacao.orientador.odocente}
          </p>

          <p>
            <i className="fas fa-users mr-[5px] text-colorPrimary"></i>
            <strong className='text-colorPrimary font-semibold'>Banca:</strong> <br />
            {dissertacao.pmembro_banca2.pmb2titulacao} <span className="capitalize">{dissertacao.pmembro_banca2.pmembrob2.toLowerCase()}</span> <br />

            {dissertacao.pmembro_banca3.pmb3titulacao} <span className="capitalize">{dissertacao.pmembro_banca3.pmembrob3.toLowerCase()} </span><br />

            {dissertacao.pmembro_banca4.pmb4titulacao} <span className="capitalize">{dissertacao.pmembro_banca4.pmembrob4.toLowerCase()}</span> <br />

            {dissertacao.pmembro_banca5.pmb5titulacao} <span className="capitalize">{dissertacao.pmembro_banca5.pmembrob5.toLowerCase()}</span> <br />
          </p>
        </div>
      </CardContent>
    </Card>
  );
}